<template>
  <master-layout id="contentBookmark">
    <BackButton variant="inline" @click="back" />
    <div v-if="!showLoading">
      <div class="md:mt-8 md:mx-[72px] px-6 lg:w-3/4 pb-[26px]">
        <div>
          <p class="page-title mb-[16px]">
            {{ myListHeader }}
          </p>
          <div v-if="
            allBookMarkList.length &&
            allBookMarkList[0].resources && allBookMarkList[0].resources.length
          ">
            <!-- eslint-disable-next-line vue/require-v-for-key -->
            <div v-for="item in allBookMarkList" class="mt-[16px]">
              <div class="mt-[36px] flex flex-row flex-wrap gap-x-[16px] gap-y-[16px] md:gap-y-[64px]">
                <ResourceCard v-for="resource in item.resources" :key="`${resource.slug}-${item.type}`"
                  :image-url="resource.thumbnail" :title="resource.title" :slug="resource.slug" :type="resource.type"
                  :tag-slug="tagSlug" :duration="resource.duration" :is-exclusive="resource.isCVPExclusive"
                  :is-audio="resource.isAudio" :avail-translations="resource.availTranslations"
                  :resource-translations="resource.resourceTranslations" class="!pr-0" @openLanguageModal="() => { }" />
              </div>
            </div>
          </div>

          <div v-else>
            <div class="text-center mt-[60px] ">
              <h1 class="text-[24px] leading-[32px] font-bold">Your List is Empty</h1>
              <p class="mt-[16px] text-[16px] leading-[20px]">As you explore resources, tap the <img
                  src="/assets/images/bookmark.svg" alt="bookmark" class="inline" /> icon <br /> to save it here.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="w-full min-h-[50svh] flex items-center justify-center">
      <loading-state />
    </div>
  </master-layout>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import ResourceCard from "@/components/ResourcesPage/PlaybackResources/ResourceCard.vue";
import BackButton from "@/components/common/BackButton.vue";
import platformMixin from "@/mixins/platformMixin";
import { FirebaseAnalytics } from "@/utils/firebase-analytics-wrapper";
import { getCurrentLocale } from "@/utils/deviceLocale";
import { bookmark } from "ionicons/icons";
import LoadingState from "@/components/common/LoadingState.vue";

export default {
  name: "ResourceSearch",
  mixins: [platformMixin],
  components: {
    ResourceCard,
    LoadingState,
    BackButton,
  },
  data() {
    return {
      bookmarkIcon: bookmark,
    };
  },
  computed: {
    ...mapState("user", ["token"]),
    ...mapState("cms", ["sessionMaterials", "loading"]),
    ...mapState("filter", ["allBookMarkList", "isLoading"]),
    ...mapGetters("filter", ["myListHeader"]),
    // Block the page with a spinner only when the store has nothing to show yet
    // (true first load). Once bookmarks are cached in the store, render them
    // immediately and let ionViewDidEnter's refetch update in the background —
    // no blank-out on revisits or on bookmark toggles from this page.
    showLoading() {
      return this.isLoading && !this.allBookMarkList.length;
    },
  },
  async ionViewDidEnter() {
    const locale = await getCurrentLocale("Regional");
    FirebaseAnalytics.setScreenName({
      screenName: "resources - mylist",
      nameOverride: "ResourcesPage - Mylist",
    });
    await this.$store.dispatch("filter/fetchBookMarkLists", {
      locale: locale,
      conferenceType: "Global",
    });
  },
  async ionViewWillLeave() { },
  methods: {
    back() {
      this.$router.back();
    },
  },
};
</script>
<style scoped>
@media all and (min-width: 768px) {
  ::v-deep(.swiper-wrapper) {
    padding-left: 0;
  }
}
</style>
